import React from "react";

const STROKE_PROPS = {
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none",
};

/** Instagram — 25×25 */
export const InstagramIcon = ({ size = 25 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M16.0833 0.75H8.08333C4.03324 0.75 0.75 4.03324 0.75 8.08333V16.0833C0.75 20.1334 4.03324 23.4167 8.08333 23.4167H16.0833C20.1334 23.4167 23.4167 20.1334 23.4167 16.0833V8.08333C23.4167 4.03324 20.1334 0.75 16.0833 0.75Z"
      {...STROKE_PROPS}
    />
    <path
      d="M12.0834 16.8913C14.7388 16.8913 16.8914 14.7387 16.8914 12.0833C16.8914 9.42794 14.7388 7.27533 12.0834 7.27533C9.42801 7.27533 7.27539 9.42794 7.27539 12.0833C7.27539 14.7387 9.42801 16.8913 12.0834 16.8913Z"
      {...STROKE_PROPS}
    />
    <path
      d="M18.6087 6.93133C19.3672 6.93133 19.982 6.31647 19.982 5.55799C19.982 4.79952 19.3672 4.18466 18.6087 4.18466C17.8502 4.18466 17.2354 4.79952 17.2354 5.55799C17.2354 6.31647 17.8502 6.93133 18.6087 6.93133Z"
      fill="currentColor"
    />
  </svg>
);

/** YouTube — 27×21 (비율 유지) */
export const YoutubeIcon = ({ size = 27 }) => {
  const height = Math.round((size * 21) / 27);

  return (
    <svg
      width={size}
      height={height}
      viewBox="0 0 27 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M0.75 9.28333C0.75 5.26067 1.15 3.24867 2.39933 1.99933C3.64867 0.75 5.66067 0.75 9.68333 0.75H17.2833C21.306 0.75 23.3167 0.75 24.5673 1.99933C25.818 3.24867 26.2167 5.26067 26.2167 9.28333V10.8327C26.2167 14.8553 25.8167 16.8673 24.5673 18.1167C23.318 19.366 21.306 19.366 17.2833 19.366H9.68333C5.66067 19.366 3.64867 19.366 2.39933 18.1167C1.15 16.8673 0.75 14.8553 0.75 10.8327V9.28333Z"
        {...STROKE_PROPS}
      />
      <path
        d="M17.0651 9.37934L11.3744 5.82334C11.2533 5.74764 11.1141 5.70575 10.9713 5.70201C10.8285 5.69827 10.6874 5.73283 10.5625 5.80209C10.4375 5.87135 10.3335 5.97278 10.261 6.09586C10.1885 6.21894 10.1503 6.35918 10.1504 6.50201V13.6153C10.1506 13.7581 10.1889 13.8981 10.2615 14.021C10.3341 14.1439 10.4382 14.2451 10.563 14.3142C10.6879 14.3833 10.829 14.4178 10.9717 14.414C11.1143 14.4102 11.2534 14.3683 11.3744 14.2927L17.0651 10.7367C17.1802 10.6648 17.2752 10.5648 17.3411 10.446C17.4069 10.3273 17.4415 10.1938 17.4415 10.058C17.4415 9.92224 17.4069 9.7887 17.3411 9.66997C17.2752 9.55124 17.1802 9.45122 17.0651 9.37934Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};
